import { render, staticRenderFns } from "./JobForm.vue?vue&type=template&id=8703f8dc&scoped=true"
import script from "./JobForm.vue?vue&type=script&lang=js"
export * from "./JobForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8703f8dc",
  null
  
)

export default component.exports